import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import PageSEO from "../Components/PageSEO";
import { send } from "emailjs-com";
import ScrollReveal from "../Components/ScrollReveal";

const heroStyle = {
  paddingTop: 64,
  paddingBottom: 80,
  background:
    "linear-gradient(0deg, rgba(0,0,0,0.55), rgba(0,0,0,0.38)), url('https://res.cloudinary.com/american-legacy-tours/image/upload/f_auto,q_auto/img/citysky') no-repeat center center",
  backgroundSize: "cover",
};

const inputStyle = {
  width: "100%",
  padding: "11px 14px",
  border: "1px solid #ddd",
  borderRadius: 4,
  background: "#fff",
  fontSize: "0.97rem",
  fontFamily: "Montserrat, sans-serif",
  marginBottom: 12,
  outline: "none",
  boxSizing: "border-box",
};

const PrivateTours = () => {
  const [sent, setSent] = React.useState(false);
  const [isSent, setIsSent] = React.useState(false);
  const [toSend, setToSend] = React.useState({});

  const onSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    send("service_thlhokp", "template_ydl9hbe", toSend, "pspiVumi2F-ZjP1oN")
      .then(() => { setIsSent(true); })
      .catch(() => { setIsSent(false); setSent(false); });
  };

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };

  return (
    <>
      <PageSEO
        title="Private Tours | American Legacy Tours"
        description="Book a private tour with American Legacy Tours! Customizable historic, haunted &amp; underground tours for corporate groups, families &amp; special events in Cincinnati."
        path="/private-tours"
      />

      <div style={heroStyle}>
        <Container>
          <h2
            style={{
              color: "#fff",
              fontWeight: 800,
              fontSize: "clamp(1.6rem, 4vw, 2.4rem)",
              marginBottom: 32,
              textShadow: "1px 2px 8px rgba(0,0,0,0.5)",
            }}
          >
            Private Tours
          </h2>

          <Row>
            <Col md={5} xs={12} className="mb-4 mb-md-0">
              <ScrollReveal direction="left">
                <div className="glass-card" style={{ marginBottom: 16 }}>
                  Since 2009, American Legacy Tours has been providing amazing tours to both
                  public and private groups in the greater Cincinnati, Ohio area. We would be
                  happy to host your next event — whether it's a birthday party, bachelor or
                  bachelorette party, corporate team building, or convention.
                </div>
                <div className="glass-card">
                  Need food and transportation? No problem. We host hundreds of private events
                  each year and our staff are experts at managing all the details for you. No
                  group is too small or too large — we specialize in customizing your experience
                  to fit the needs of your group.
                </div>
              </ScrollReveal>
            </Col>

            <Col md={7} xs={12}>
              <ScrollReveal direction="right" delay={80}>
                <div className="glass-card">
                  <h4 style={{ fontWeight: 700, marginBottom: 20 }}>Request a Private Tour</h4>
                  <form onSubmit={onSubmit}>
                    <input
                      type="text"
                      name="from_name"
                      placeholder="Your Name"
                      value={toSend.from_name || ""}
                      onChange={handleChange}
                      required
                      style={inputStyle}
                    />
                    <input
                      type="tel"
                      name="from_phone"
                      placeholder="Your Phone"
                      value={toSend.from_phone || ""}
                      onChange={handleChange}
                      style={inputStyle}
                    />
                    <input
                      type="email"
                      name="reply_to"
                      placeholder="Your Email"
                      value={toSend.reply_to || ""}
                      onChange={handleChange}
                      required
                      style={inputStyle}
                    />
                    <input
                      type="date"
                      name="event_date"
                      placeholder="Preferred Date"
                      value={toSend.event_date || ""}
                      onChange={handleChange}
                      style={inputStyle}
                    />
                    <textarea
                      name="message"
                      placeholder="Tell us about your group and what you're looking for..."
                      value={toSend.message || ""}
                      onChange={handleChange}
                      required
                      rows={5}
                      style={{ ...inputStyle, resize: "vertical", marginBottom: 16 }}
                    />
                    {!sent && (
                      <button type="submit" className="btn-brand" style={{ width: "100%", fontSize: "1rem" }}>
                        Send Request
                      </button>
                    )}
                    {isSent && (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "16px",
                          background: "#e8f5e9",
                          borderRadius: 4,
                          color: "#2e7d32",
                          fontWeight: 600,
                        }}
                      >
                        Request sent! We'll be in touch soon.
                      </div>
                    )}
                  </form>
                </div>
              </ScrollReveal>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default PrivateTours;
